/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const actionTypes = {
  PROVIDERS_API_REQUEST: 'PROVIDERS_API_REQUEST',
  PROVIDERS_API_FAILURE: 'PROVIDERS_API_FAILURE',
  FETCH_PROVIDERS: 'FETCH_PROVIDERS',
  FETCH_ASSOCIABLE_SERVICES: 'FETCH_ASSOCIABLE_SERVICES',
  CREATE_PROVIDER: 'CREATE_PROVIDER',
  UPDATE_PROVIDER: 'UPDATE_PROVIDER',
  SET_DELETE_PROVIDER_LOADING: 'SET_DELETE_PROVIDER_LOADING',
  DELETE_PROVIDER: 'DELETE_PROVIDER',
  ARCHIVE_PROVIDER: 'ARCHIVE_PROVIDER',
  RESTORE_PROVIDER: 'RESTORE_PROVIDER',
  SET_ARCHIVE_PROVIDER_LOADING: 'SET_ARCHIVE_PROVIDER_LOADING',
  PROVIDERS_CLEANUP: 'PROVIDERS_CLEANUP',
  UPDATE_PROVIDERS_INPUT: 'UPDATE_PROVIDERS_INPUT',
  UPDATE_PROVIDERS_PILL: 'UPDATE_PROVIDERS_PILL',
  PROVIDERS_FUNCTIONS: 'PROVIDERS_FUNCTIONS',

  UPDATE_ALL_PROVIDERS_SEARCH_INPUT: 'UPDATE_ALL_PROVIDERS_SEARCH_INPUT',
  UPDATE_ARCHIVE_PROVIDERS_SEARCH_INPUT:
    'UPDATE_ARCHIVE_PROVIDERS_SEARCH_INPUT',
  UPDATE_ARCHIVE_SERVICES_SEARCH_INPUT: 'UPDATE_ARCHIVE_SERVICES_SEARCH_INPUT',

  SERVICES_API_REQUEST: 'SERVICES_API_REQUEST',
  SERVICES_API_FAILURE: 'SERVICES_API_FAILURE',
  FETCH_SERVICES: 'FETCH_SERVICES',
  CREATE_SERVICE: 'CREATE_SERVICE',
  UPDATE_SERVICE: 'UPDATE_SERVICE',
  DELETE_SERVICE: 'DELETE_SERVICE',
  SET_DELETE_SERVICE_LOADING: 'SET_DELETE_SERVICE_LOADING',
  ARCHIVE_SERVICE: 'ARCHIVE_SERVICE',
  RESTORE_SERVICE: 'RESTORE_SERVICE',
  SET_ARCHIVE_SERVICE_LOADING: 'SET_ARCHIVE_SERVICE_LOADING',
  SERVICES_CLEANUP: 'SERVICES_CLEANUP',
  UPDATE_SERVICES_INPUT: 'UPDATE_SERVICES_INPUT',
  UPDATE_SERVICES_PILL: 'UPDATE_SERVICES_PILL',
  UPDATE_MULTI_SELECT_PROVIDER: 'UPDATE_MULTI_SELECT_PROVIDER',
  FETCH_ACTIVE_PROVIDERS_IN_SERVICES: 'FETCH_ACTIVE_PROVIDERS_IN_SERVICES',
  FETCH_ASSOCIABLE_COMPONENTS: 'FETCH_ASSOCIABLE_COMPONENTS',

  UPDATE_ALL_SERVICES_SEARCH_INPUT: 'UPDATE_ALL_SERVICES_SEARCH_INPUT',

  COMPONENTS_API_REQUEST: 'COMPONENTS_API_REQUEST',
  COMPONENTS_API_FAILURE: 'COMPONENTS_API_FAILURE',
  FETCH_COMPONENTS: 'FETCH_COMPONENTS',
  FETCH_ACTIVE_COMPONENTS: 'FETCH_ACTIVE_COMPONENTS',
  FETCH_FRAMEWORKS: 'FETCH_FRAMEWORKS',
  CREATE_COMPONENT: 'CREATE_COMPONENT',
  UPDATE_COMPONENT: 'UPDATE_COMPONENT',
  DELETE_COMPONENT: 'DELETE_COMPONENT',
  ARCHIVE_COMPONENT: 'ARCHIVE_COMPONENT',
  RESTORE_COMPONENT: 'RESTORE_COMPONENT',
  SET_ARCHIVE_COMPONENT_LOADING: 'SET_ARCHIVE_COMPONENT_LOADING',
  COMPONENTS_CLEANUP: 'COMPONENTS_CLEANUP',
  UPDATE_COMPONENTS_INPUT: 'UPDATE_COMPONENTS_INPUT',
  UPDATE_COMPONENTS_PILL: 'UPDATE_COMPONENTS_PILL',
  UPDATE_MULTI_SELECT_COMPONENT: 'UPDATE_MULTI_SELECT_COMPONENT',
  FETCH_ASSOCIABLE_APPLICATIONS: 'FETCH_ASSOCIABLE_APPLICATIONS',
  FETCH_ACTIVE_SERVICES_IN_COMPONENTS: 'FETCH_ACTIVE_SERVICES_IN_COMPONENTS',
  FETCH_COMPONENTS_GRAPH_DEPENDENCIES: 'FETCH_COMPONENTS_GRAPH_DEPENDENCIES',

  UPDATE_ALL_COMPONENTS_SEARCH_INPUT: 'UPDATE_ALL_COMPONENTS_SEARCH_INPUT',
  SET_DELETE_COMPONENT_LOADING: 'SET_DELETE_COMPONENT_LOADING',
  ASSOCIABLE_APPS: 'ASSOCIABLE_APPS',
  FETCH_COMPONENTS_SERVICE_DEPENDENCIES:
    'FETCH_COMPONENTS_SERVICE_DEPENDENCIES',
  UPDATE_COMPONENTS_SERVICE_DEPENDENCIES:
    'UPDATE_COMPONENTS_SERVICE_DEPENDENCIES',
  SET_DISCOVER_COMPONENT_LOADING: 'SET_DISCOVER_WORKFLOW_COMPONENT_LOADING',

  // Evaluate
  EVALUATE_API_REQUEST: 'EVALUATE_API_REQUEST',
  MANUAL_LABEL_API_REQUEST: 'MANUAL_LABEL_API_REQUEST',
  MANUAL_LABEL_API_COMPLETE: 'MANUAL_LABEL_API_COMPLETE',
  CREATE_EVAL_JOB_API_REQUEST: 'CREATE_EVAL_JOB_API_REQUEST',
  FETCH_TEMPLATE_API_REQUEST: 'FETCH_TEMPLATE_API_REQUEST',
  EVALUATE_STATUS_API_REQUEST: 'EVALUATE_STATUS_API_REQUEST',
  INF_EVALUATE_STATUS_API_REQUEST: 'INF_EVALUATE_STATUS_API_REQUEST',
  CONV_EVALUATE_STATUS_API_REQUEST: 'CONV_EVALUATE_STATUS_API_REQUEST',
  SET_DYNAMIC_LOADING: 'SET_DYNAMIC_LOADING',
  EVALUATE_API_FAILURE: 'EVALUATE_API_FAILURE',
  FETCH_EVALUATE_TEMPLATES: 'FETCH_EVALUATE_TEMPLATES',
  FETCH_EVALUATE_JOBS: 'FETCH_EVALUATE_JOBS',
  POST_EVALUATE_JOB: 'POST_EVALUATE_JOBS',
  FETCH_EVALS: 'FETCH_EVALS',
  FETCH_EVALS_REPORT: 'FETCH_EVALS_REPORT',
  FETCH_EVALS_RESET: 'FETCH_EVALS_RESET',
  FETCH_SPAN_EVALS: 'FETCH SPAN EVALS',
  FETCH_SPAN_EVALS_RESET: 'FETCH SPAN EVALS RESET',
  FETCH_INF_EVALS: 'FETCH_INF_EVALS',
  FETCH_INF_EVALS_RESET: 'FETCH_INF_EVALS_RESET',
  FETCH_CONVERSATION_EVALS: 'FETCH CONVERSATION EVALS',
  FETCH_CONVERSATION_EVALS_RESET: 'FETCH CONVERSATION EVALS RESET',
  FETCH_TRACE_EVALS: 'FETCH TRACE EVALS',
  FETCH_TRACE_EVALS_RESET: 'FETCH TRACE EVALS RESET',
  FETCH_TRACE_EVAL_REPORT: 'FETCH TRACE EVAL REPORT',
  FETCH_TRACE_EVAL_REPORT_RESET: 'FETCH TRACE EVAL REPORT RESET',
  SET_FACT_WHILE_EVAL_SUBMISSION: 'SET_FACT_WHILE_EVAL_SUBMISSION',
} as const;
